import { createContext, useContext, useState } from "react";
import type { FormValues } from "./validation-schema";

export type ConsultationFormContextType = {
  values: FormValues;
  setValues: (
    values: FormValues | ((prevState: FormValues) => FormValues),
  ) => void;
};

export const ConsultationFormContext =
  createContext<ConsultationFormContextType>(null);
export const useConsultationFormContext = () => {
  const context = useContext(ConsultationFormContext);

  if (context === null) {
    throw new Error(
      "useConsultationFormContext must be used within a ConsultationFormProvider",
    );
  }

  return context;
};

export const ConsultationFormProvider: FCwC<{ initialValues?: FormValues }> = ({
  initialValues,
  children,
}) => {
  const [values, setValues] = useState<FormValues>(initialValues);
  return (
    <ConsultationFormContext.Provider value={{ values, setValues }}>
      {children}
    </ConsultationFormContext.Provider>
  );
};
